import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IImageUpload} from './interface/upload.interface';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  api: string;
  API_URL = '/v1/api/';

  constructor(private http: HttpClient, @Inject('config') config) {
    this.api = config.apiUrl;
  }

  fetchList(): Observable<IImageUpload[]> {

    return this.http.get<IImageUpload[]>(this.api + 'images?page=1');

  }

// [ngClass]="status ? 'selectedImg' : 'unselectedImg'"
  searchImages(imageStr: string): Observable<IImageUpload[]> {
    return this.http.get<IImageUpload[]>(this.API_URL + `images?page=1&s=${imageStr}`);
  }

  saveImages(files: File[]): Observable<any> {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
      console.log(file);

    });
    return this.http.post<any>(this.api , formData);
  }

  saveImagesByUrl(image): Observable<any> {
    const files = [];
    files.push({
      file_name: image.file_name || '',
      file_path: image.file_path
    });
    return this.http.post<any>(this.API_URL + 'upload_url', files);
  }

}
